import { useLanguage } from "../i18n/LanguageContext";

const LanguageSwitcher = ({ className = "" }) => {
  const { isArabic, toggleLanguage } = useLanguage();

  return (
    <button
      type="button"
      className={`hpa-language-switch ${className}`.trim()}
      onClick={toggleLanguage}
      aria-label={isArabic ? "Switch to English" : "التبديل إلى العربية"}
    >
      <i className="fa-solid fa-globe" aria-hidden="true" />
      <span>{isArabic ? "English" : "العربية"}</span>
    </button>
  );
};

export default LanguageSwitcher;
